import { useDisclosure } from '@chakra-ui/react'
import { useFormContext } from '@missionlabs/react'
import { RecordingDrawer, RecordingDrawerProps } from 'features/settings/components/RecordingDrawer'
import { FC, useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useUploadRecording } from 'shared/hooks/useUploadRecording'

import { AddEditTeamFields } from './AddEditTeam/addEditTeamSchema'

export const UploadClipTeamDrawer: FC = () => {
    const location = useLocation()
    const navigate = useNavigate()
    const state = location.state as string | null

    const { isOpen, onClose } = useDisclosure({ defaultIsOpen: true })
    const {
        setValue,
        formState: { isSubmitted }
    } = useFormContext<AddEditTeamFields>()

    const { uploadRecording, isLoading } = useUploadRecording()

    const handleSubmit: RecordingDrawerProps['onSubmit'] = async file => {
        if (!file || !state) return

        const URL = await uploadRecording(file)
        setValue(state as any, URL, { shouldValidate: isSubmitted })
        return onClose()
    }

    function handleTransition() {
        navigate(-1)
    }

    useEffect(() => {
        if (!state) navigate('/admin/teams')
    }, [navigate, onClose, state])

    return (
        <RecordingDrawer
            isLoading={isLoading}
            isOpen={isOpen}
            onClose={onClose}
            onCloseComplete={handleTransition}
            onSubmit={handleSubmit}
        />
    )
}
